<template>
  <div id="app">
    <div v-if="loginShouldBeVisible" class="container-fluid">
      <div class="aspNetHidden">
      </div>
      <div style="clear: both;">
      </div>
      <div class="row no-gutters justify-content-md-between mt-4 ml-5">
        <div class="col-md-10 header-title">
          <img src="@/assets/EY_Logo_Beam_RGB.jpg" alt="EY" height="40" width="40" />
          <span class="ml-4">
            EYTaxSpace 
            <sup>TM</sup> | &nbsp;Employee Unit Management
          </span>
        </div>
      </div>
      <div id="loginStat" style="padding-top:50px;margin-left:120px;">
        <div v-if="$authStatus==5" class="auth-message" @signinChange="updateSigninMessage">
          <i class="fa fa-caret-right" style="vertical-align:middle;font-size:1.5em;color:#FFE600;margin-right:2px;" aria-hidden="true"></i>
          <div style="vertical-align:middle;display:inline-block;">You have been signed out of EUM</div>
        </div>
      </div>
      <div id="loginStatMessages" style="margin-left:120px;">
        <div v-if="$authStatus==1 || $authStatus == 2" class="auth-message" style="display:block;" @signinChange="updateSigninMessage">
          <i class="fa fa-caret-right" style="vertical-align:middle;font-size:1.5em;color:#FFE600;margin-right:2px;" aria-hidden="true"></i>
          <div style="vertical-align:middle;display:inline-block;">Signing In</div>
        </div>
        <div v-if="$authStatus==3" class="auth-message" style="display:block;" @signinChange="updateSigninMessage">
          <i class="fa fa-caret-right" style="vertical-align:middle;font-size:1.5em;color:#FFE600;margin-right:2px;" aria-hidden="true"></i>
          <div style="vertical-align:middle;display:inline-block;">Signed In</div>
        </div>
        <div v-if="$authStatus==3" class="auth-message " @signinChange="updateSigninMessage">
          <i class="fa fa-caret-right" style="vertical-align:middle;font-size:1.5em;color:#FFE600;margin-right:2px;" aria-hidden="true"></i>
          <div style="vertical-align:middle;display:inline-block;">Loading</div>
        </div>
        <div v-if="$authStatus==4" class="auth-message " @signinChange="updateSigninMessage">
          <i class="fa fa-caret-right" style="vertical-align:middle;font-size:1.5em;color:#FFE600;margin-right:2px;" aria-hidden="true"></i>
          <div style="vertical-align:middle;display:inline-block;">Error</div>
        </div>
      </div>
      <form id="form1" method="post" action="/home">
        <div id="divSignIn" class="signin">
          <div class="Form-Content">
            <div v-if="!$loginInProgress" id="divDropDown" style="padding-left: 120px;" @signinChange="updateSigninMessage">
              <Login />
            </div>
          </div>
        </div>
      </form>
 
      <h1 v-show="false" class="signin-h1" @signinChange="updateSigninMessage">
        EUM Sign In
      </h1>
    </div>
    <!-- <h2 v-if="signinMode" class="signin signin-h2">
              Select how you want to sign in to the EUM site:
            </h2> -->
    <br />
    <br />
    <div v-if="!loginShouldBeVisible" class="container-fluid" style="clear:both;">
      <Header v-if="!loginShouldBeVisible" :user="userFullName"></Header>
      <div class="my-2">
        <router-view />
        <!-- <vue-progress-bar></vue-progress-bar> -->
      </div>
      <Footer></Footer>    
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters,mapState } from "vuex";

import Header from "@/components/layout/Header.vue";
import Footer from "@/components/layout/Footer.vue";
import Login from './components/Login';
import graph from '@/services/graph.js';
import funcUtil from "@/services/funcUtil.js";
import apiUtil from "@/services/apiUtil.js";
import cookieUtil from "@/services/cookieUtil.js";
import BaseModelProgram from '@/models/BaseModelProgram.js'
import BaseModelInputControl from '@/models/BaseModelInputControl.js'
import { isNullOrUndefined } from "util";
//import localStorageUtil from '@/services/localStorageService.js';

const _self = this
export default {
   name: "App",
  components: { Login, Header, Footer },
  mixins: [funcUtil, apiUtil,cookieUtil],
  msalApp: {},
  
  data: function() {
    return {
  
      accessToken: '',
      idToken: '',
      tempdata: [],
      inputControlData: [],
      loginStatus: '',
      signinMode: 0,
      
      attempted: {},
      // Details fetched from Graph API, user object and photo
      graphDetails: null,
      graphPhoto: null,

      // Visibility toggles for the three details modal popups
      showUserDetails: false,
      showGraphDetails: false,
      showTokenDetails: false,

      // Any errors
      error: '',
      enabled: false,
      idleTimeout:!isNullOrUndefined(process.env.VUE_APP_idleTimeout)?process.env.VUE_APP_idleTimeout:5, // =>30 minutes * 60000 millisecond
      idleSecondsCounter :0,
      isTimedOut:false,
    }
  },
  computed: {

      userFullName: function(){
        if (this.$store.getters['authModule/user']){
          return this.$store.getters['authModule/user'].name;
        } else {
          return 'Unknown';
        }
      
      
      //return this.$store.getters['authModule/msalUserFullName'];
      },
      $eumAuth: function(){
        return this.$root.$eumAuth;
      },
      $msalClientApp: {
        get() {
          if ( this.$store ) {
            return this.$store.getters["authModule/msalApp"];
          } else {
             return null;
          }
        },
        set(val) {
          this.$store.dispatch("authModule/setMsalApp",val);
        }
       
      },
      
         $authStatus: {
        get() {
          return this.$store.getters['authModule/authStatus'];        
        },
        set(val) {
          this.$store.dispatch('authModule/SetAuthStatus',val);

        }
         },
     
      authorizedUser: function(){
        return this.storedAppUser;
      },
      api_idtoken: function(){
        return this.$store.getters['authModule/api_idtoken'];
      },
      user: {
          get() { return this.$store.getters['authModule/msalUser']},
          set(val) { this.value = val;}
      },
        $loginInProgress: function(){
       return this.$store.getters['authModule/loginInProgress'];
     },
    
      ...mapState("getModule", ["errorMsg"]),
      ...mapGetters("authModule",["userIsAuthenticated","storedAppUser","userIsAuthorized","loginShouldBeVisible","msalUserFullName"]),
      ...mapGetters("getModule",["listHasData","InitialGetCalled"]),
      msalClient: function(){
          return this.$store.getters['authModule/msalApp'];
      },
      firstAuthFlag: {
        get() { 
                return this.$store.getters['authModule/isFirstAuth'];
               }
      }
      // authorizedUser: function(){
      //   return this.$store.getters['authModule/authUser'];
      // }
    }, 
  watch: {
      $authStatus: function(value){

          console.log(`authstatus changed - new value is ${value}`);
      },
      userIsAuthorized: function(value){
        console.log(`App.vue WATCH(userIsAuthorized) triggers newValue=${value}`);
       // this.fetchGraphUserName()
        // if (value === true){
        //     setTimeout(function(){
        //     if ( !_self.InitialGetCalled){
        //       console.log(`------------------------------------------appUser watch - initialGetCalled is FALSE`);
        //       _self.GetAllItemsUnbundled();
        //     }
        //  },1000);
        
      //   }
      },
     
      appUser: function(oldVal, newVal){
        console.log(' ----- appUser WATCH triggered... newVal=',newVal);
      },
      // authorizedUser: function(value){
      //   console.log(`App.vue WATCH(authorizedUer) triggers`,value);
      //    if (value === true){
      //       setTimeout(function(){
      //       if ( !self.InitialGetCalled){
      //         console.log(`------------------------------------------appUser watch - initialGetCalled is FALSE`);
      //         self.GetAllItemsUnbundled();
      //       }
      //    },1000);
      // }},
      idToken:function(val){
        if (this.user != null){
          this.user.idToken = val;
        };
      },
      accessToken:function(val){
         if (this.user != null){
          this.user.accessToken = val;
         };
      },

      // appUser: async function(val){

      //    console.log(` --- appUser watch triggered`);
      //    let self = this;
      //    this.user = val;

      //    setTimeout(function(){
      //      if ( !self.InitialGetCalled){

      //          console.log(`------------------------------------------appUser watch - initialGetCalled is FALSE`);
      //         self.GetAllItemsUnbundled();
      //      }
      //    },1000);
         
      //  },
      //  user: async function() {
      //     await this.fetchGraphDetails();
      //  }

  },
  mounted: function() {
     console.log('-------- App.vue MOUNTED --------');
      this.signinMode = 0;
      this.$on('eum-auth-failed', () => {
        //this.test()
       // this.shallowLogout();
        this.signinMode = false;
        setTimeout(() => { 
      for (let entry of Object.entries(localStorage)) {
        let key = entry[0]
        if (key.includes('login.windows')) {
          localStorage.removeItem(key)
        }
      
    }},500);
        console.log(`this.signinMode = `,this.signinMode);
      });
    },
    created() {
    console.log(`[App.vue] Created() process.env.NODE_ENV = ${process.env.NODE_ENV}`)
    console.log(`VUE_APP_ApiBaseUrl = ${process.env.VUE_APP_ApiBaseUrl}`)
    console.log(`VUE_APP_CLIENT_ID = ${process.env.VUE_APP_CLIENT_ID}`)
    console.log(`VUE_APP_siteUrl = ${process.env.VUE_APP_siteUrl}`)
    console.log(`VUE_APP_siteRelativeUrl = ${process.env.VUE_APP_siteRelativeUrl}`)
    console.log(`VUE_APP_fileFlag = ${process.env.VUE_APP_fileFlag}`)
   
    //let res = await this.$http.get("/api/InputControl");

    //test the store
    this.$store.dispatch('authModule/SetInstanceName','started-in-appvueinmystore');

   //let store;
    // let healthcheck = this.$eumAuth.checkApiHealth();
    // console.log(`healthcheck = ${health}`);
    // Basic setup of MSAL helper with client id, or give up
    let self = this;
    if (this.signinMode == 0){
        this.$eumAuth.user(false).then(res => {
          self.user = res;

        })

    }


    // if (this.signinMode == 0){
    //    let usr = await this.$eumAuth.user(false);
    //    if (usr){
    //      self.user = usr;
    //    } else {
    //       //this.$store.dispatch("authModule/SetLoginInProgress",true);

    //    }
   // }
   
   if ( this.$store.getters['authModule/authorized'] ){
            console.log('authorize complete, calling BaseModelInputControl list');
          self.GetItems(BaseModelInputControl);
          console.log('authorize complete, calling BaseModelProgram list');
          self.GetItems(BaseModelProgram);
          this.$store.dispatch('authModule/SetFirstLoginInProg',false);
        self.GetAllItemsUnbundled();
     }
     
    

    
    document.onclick = function () {
        self.idleSecondsCounter = 0;
    };
    document.onkeypress = function () {
      self.idleSecondsCounter = 0;   
    };
    if (!(process.env.VUE_APP_DigestRefreshInterval === undefined || process.env.VUE_APP_DigestRefreshInterval === null)) {
        setInterval(function() {
          self.checkIdleTime();
        }, process.env.VUE_APP_DigestRefreshInterval);
      }


   if (self.user != undefined && self.user != null){
      this.enabled = true;
      console.log(
        "Refresh Interval " + process.env.VUE_APP_APIRefreshInterval + " ms"
      );
      if (!isNullOrUndefined(process.env.VUE_APP_APIRefreshInterval)) {
        setInterval(function() {

          self.BusinessEventRefresh();
        }, process.env.VUE_APP_APIRefreshInterval);
      }
   }

   if ( this.$store.getters['authModule/authorized'] ){
     this.$store.dispatch('authModule/SetFirstLoginInProg', false);
    }
    },
 
  methods : {
      ...mapActions("getModule", ["GetAllItems", "GetUpdatedItems","GetAllItemsUnbundled","GetItems"]),
      ...mapActions("authModule", ["SetLoggedInUser","LogoutUser","SetLoginInProgress"]),
 
    hideSignin() {
     // console.log(' HIDESIGNIN METHOD');
    },
    async updateSigninMessage(){
      console.log('updateSigninMessage!')

    },
    async updateUser() {

      console.log(`[App.vue] updateUser() going to call auth.acquireIdToken`);
      let self = this;
      let tkn = await this.$eumAuth.acquireToken();
      console.log(`[App.vue] updateUser() back from auth.acquireIdToken`);
   
      
      this.user = this.$eumAuth.user()
   
    },
  
    async afterPopupLogout(popupLogoutResp){
       

    },
     async shallowLogout() {
      //    try {
      //  // let currentAccount = this.$eumAuth._msalClient.getAllAccounts()[0];
      //  } catch(err){

      //    console.log('Error getting currentaccount in msal:',err)
      //  }
       this.$authStatus = 5;
       this.$eumAuth.clearLocal();
        this.user = null;
        this.signinMode = 5
        this.$emit('signinChange')
        this.SetLoginInProgress = false;
        this.LogoutUser();
        
        
        // this.graphDetails = null
        // this.userDetails = null
        // this.graphPhoto = null

 
        
        //this.LogoutUser();
    },
   
    fullLogout() {
      this.$eumAuth.logout()
    },
    getLoggedInUser(){
      return this.$eumAuth.user();

    },
    // getSomeData - test method
    async getSomeData(listname)
    {
      let self = this;
      const res = await fetch(`${process.env.VUE_APP_ApiBaseUrl}/${listname}/`,
      { 
        headers: {
        authorization:`bearer ${self.user.idToken}`
      }
     })
     const data = await res.json()
     this.posts = data;
     return this.posts;
		//return this._decodeResponseObject(result);

    },
    parseJwt (token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
},
    BusinessEventRefresh() {

      let self = this;
      if (this.userIsAuthorized){
      if(!this.isTimedOut ){
          console.log("Business Event Data Refreshing");
          let ListToBeUpdated = {
      //      Program: {config:""},
          Issuance: { config: "" },
          Transfer: { config: "" },
          Vesting: { config: "" },
          Buyout: { config: "" },
          // Correction: { config: "" },
          InformationTracker: { config: "" }
        };
      this.GetUpdatedItems(ListToBeUpdated).then(res => {
        console.log("Business Event Data Refreshed");
        if (
          $("#issuanceGrid").length > 0 ||
          $("#TransferGrid").length > 0 ||
          $("#vestingGrid").length > 0 ||
          // $("#CorrectionGrid").length > 0 ||
          $("#vestingReportGrid").length > 0 ||
          $("#TransferReportGrid").length > 0 ||
          $("#issuanceReportGrid").length > 0 ||
          $("#InformationTrackingGrid").length > 0
        ) {
          $("a#btnRefresh").addClass("btnGlow");
        }
      });
       }
      }
    },
    async fetchDigestFromSharepoint() 
    {
      try {
        // let digest=await axios.post(`${process.env.VUE_APP_siteUrl}` + `/_api/contextinfo`,{ body: ""});
        // console.log("digeststatus",digest.status);
        // return (digest.status && digest.status==200)?true:false;
        return true

      }
      catch {
            return true;
      }   
    },
    async fetchGraphDetails() {
      let self = this;
      if (!this.user || this.user.username == 'demo@example.net') {
        return
      }

      try {
         self.graphDetails = await graph.getSelf()
         self.accessToken = graph.getAccessToken()
         self.idToken = graph.getIdToken();

         console.log('idtoken: ' + this.idToken);
         return self;
      } catch (err) {
        this.error = err
      }
    },
 async fetchGraphUserName() {
      let self = this;
      if (!this.user || this.user.username == 'demo@example.net') {
        return
      }

      try {
        let self = await this.$eumAuth.getSelf();
        let name = 'blah';
         return name;
      } catch (err) {
        this.error = err
      }
    },
    checkIdleTime() {
      const self=this;
       if(!self.isTimedOut ){
          self.idleSecondsCounter=self.idleSecondsCounter+1;
          console.log("Minutecounter",self.idleSecondsCounter);
             
          if (self.idleSecondsCounter >= self.idleTimeout ) {
             self.isTimedOut=true;
             self.shallowLogout();
                window.location.href = `${process.env.VUE_APP_frontEndUrl}`;                 
            }
       }

  }},
 
 
}
</script>
<style lang="scss">
@import "@/assets/fonts/font-awesome/scss/font-awesome.scss";
@import "@/assets/styles/styles.scss";
@import "@/assets/styles/ey-motif.scss";
#app {
  font-family: "Noto Sans", Arial, "Avenir", Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  font-size: 14px;
}

html {
  height: 100%;
}

body {
  position: relative;
  margin: 0;
  min-height: 100%;
  padding-bottom: 7rem;
}
// .row {margin-left:-15px !important;}
// .my-2 {
//   padding-left: 25px !important;
//   padding-right: 25px !important;
// }
.ml-4 {
    margin-left: 1rem !important;
}
.row.mt4.mt5 {
  margin-left:48px !important;
  margin-top:24px !important;
}


.signin-h1 {
  padding-left: 120px; 
  padding-bottom: 18px; 
  padding-top: 100Px; 
  font-weight: normal;
  color:$ey-primary;
   font-size: 2.1em !important; 
   font-family:  "Noto Sans", Arial, Avenir, Helvetica, sans-serif;
}
.signin {padding-top: 30px; font-size: 18px; font-family: "Noto Sans", Arial, Avenir, Helvetica, sans-serif;color:$ey-primary}
//.signin.login {font-size: 16px;}
.signin-h2 {
  padding-left: 120px; 
  font-size: 18px; 
  font-family:  "Noto Sans", Arial, Avenir, Helvetica, sans-serif;
  color:$ey-primary;
  font-weight:normal !important;}
  .secondary { padding-left:0px;}
.auth-message {
  display:inline-block;
  font-size: 18px; 
  font-family:  "Noto Sans", Arial, Avenir, Helvetica, sans-serif;
  color:$ey-primary;
  font-weight:normal !important;
  margin-bottom:12px;
}

.signin-btn {
  font-size: 16px;
}
.k-grid-content {
  min-height: 200px  !important;
}
</style>
